import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import {
	DcArrayPipeModule,
	DcTruncatePipeModule,
} from '@datachain/ui-sdk/pipes';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { PermissionListComponent } from './components/permission-list/permission-list.component';

@NgModule({
	declarations: [PermissionListComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		UiModule,
		MaterialModule,
		DcPageModule,
		DcBreadcrumbModule,
		DcPanelModule,
		DcArrayPipeModule,
		DxDataGridModule,
		DcTruncatePipeModule,
	],
})
export class PermissionModule {
	public constructor(private readonly injector: Injector) {
		const permissionListComponent = createCustomElement(
			PermissionListComponent,
			{
				injector,
			}
		);
		customElements.define('app-permission-list', permissionListComponent);
	}
}
